import { render, staticRenderFns } from "./limitation.vue?vue&type=template&id=67552bd4&scoped=true&"
import script from "./limitation.vue?vue&type=script&lang=js&"
export * from "./limitation.vue?vue&type=script&lang=js&"
import style0 from "./limitation.vue?vue&type=style&index=0&id=67552bd4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67552bd4",
  null
  
)

export default component.exports